import type { StaffMemberDto, AttendeeListItemDto } from '@/api/admin'
import type { PortalStaffMemberDto } from '@/api/portal'
import type { AttendeeProfile } from '@/api/attendee'
import { PhotoAvatar } from './PhotoAvatar'
import { useAdminStaffPhoto, usePortalStaffPhoto, useAdminAttendeePhoto, useSelfAttendeePhoto } from './photoSources'

// One tiny component per audience, so pages can drop an avatar into a row (hooks can't run inside a .map()).

export function AdminStaffAvatar({ member, clientId, size }: { member: StaffMemberDto; clientId: string; size?: number }) {
  return <PhotoAvatar source={useAdminStaffPhoto(member, clientId)} size={size} />
}

export function PortalStaffAvatar({ member, canEdit, size }: { member: PortalStaffMemberDto; canEdit: boolean; size?: number }) {
  return <PhotoAvatar source={usePortalStaffPhoto(member, canEdit)} size={size} />
}

export function AdminAttendeeAvatar({ attendee, size }: { attendee: Pick<AttendeeListItemDto, 'id' | 'fullName' | 'photoUpdatedAt'>; size?: number }) {
  return <PhotoAvatar source={useAdminAttendeePhoto(attendee)} size={size} />
}

export function SelfAttendeeAvatar({ profile, size }: { profile: AttendeeProfile; size?: number }) {
  return <PhotoAvatar source={useSelfAttendeePhoto(profile)} size={size} />
}
